import { ConnectKitButton } from "connectkit";
import logo from "../public/vertex-logo.png";

function Nav() {
  return (
    <div className="flex justify-between mt-10 gap-2">
      <div>
        <img src={logo} alt="logo" className="object-contain w-32" />
        <p className="text-primary-text text-md font-bold mt-1">
          trading competition
        </p>
      </div>
      <div>
        <ConnectKitButton />
      </div>
    </div>
  );
}

export default Nav;
